import { IconButton, Tooltip, styled } from '@mui/material';
import { Editor } from '@tiptap/react';
import { Iconify } from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { useConversationContext } from 'src/provider/ConversationContext';
import { ConversationMessageReply } from '../ConversationMessageReply';

export const ConversationReplyToMessage = ({ editor }: { editor: Editor }) => {
  const { replyTo, setReplyTo } = useConversationContext();
  const { translate } = useLocales();

  if (!replyTo) return null;

  return (
    <StyledReplyContainer>
      <ConversationMessageReply message={replyTo} editor={editor} />
      <Tooltip title={translate('shared.tooltip.cancel_reply')}>
        <IconButton
          sx={{
            alignSelf: 'center',
            border: (theme) => `1px solid ${theme.palette.divider}`,
          }}
          size="small"
          onClick={() => setReplyTo(null)}
        >
          <Iconify icon="tabler:x" sx={{ width: 16, height: 16 }} />
        </IconButton>
      </Tooltip>
    </StyledReplyContainer>
  );
};

export const StyledReplyContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  width: '100%',
  paddingBottom: theme.spacing(1),
  marginBottom: theme.spacing(1),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));
